import React from 'react';
import AIAssistant from '../components/AIAssistant';
import AgentDashboardHome from '../components/AgentDashboardHome';
import EmailHistory from '../components/EmailHistory';
import EscalationsPage from '../components/escalations/EscalationsPage';
import PromoComboViewer from '../components/PromoComboViewer';
import RogersPricingViewer from '../components/RogersPricingViewer';
import SendOffer from '../components/SendOffer';
import TrainingTest from '../components/TrainingTest';
import TrainingViewer from '../components/TrainingViewer';
import NewTrainingViewer from '../components/NewTrainingViewer';
import TvPackageRecommender from '../components/TvPackageRecommender';
import TvPackageRecommenderV2 from '../components/TvPackageRecommenderV2';
import AgentDashboardManager from '../components/admin/AgentDashboardManager';
import BundleBuilderPrototype from '../components/admin/BundleBuilderPrototype';
import EmailSettings from '../components/admin/EmailSettings';
import NewTrainingManagement from '../components/admin/NewTrainingManagement';
import ProductPricingManagerComingSoon from '../components/admin/ProductPricingManagerComingSoon';
import SDS from '../components/admin/SDS';
import SystemReports from '../components/admin/SystemReports';
import TemplateManagement from '../components/admin/TemplateManagement';
import ThemePackEditor from '../components/admin/ThemePackEditor';
import TrainingManagement from '../components/admin/TrainingManagement';
import TrainingTestManagement from '../components/admin/TrainingTestManagement';
import TvPackagePricing from '../components/admin/TvPackagePricing';
import TvPackagePricingV2 from '../components/admin/TvPackagePricingV2';
import UserManagement from '../components/admin/UserManagement';
import ZoomIdleReport from '../components/admin/ZoomIdleReport';

const renderEscalations = ({
    escalationsAvailability,
    escalationsAvailabilityLoaded,
    onEscalationsAvailabilityChange
}) => (
    <EscalationsPage
        availability={escalationsAvailability}
        availabilityLoaded={escalationsAvailabilityLoaded}
        onAvailabilityChange={onEscalationsAvailabilityChange}
    />
);

export const ADMIN_VIEW_RENDERERS = Object.freeze({
    'ai-assistant': () => <AIAssistant />,
    users: () => <UserManagement />,
    templates: () => <TemplateManagement />,
    'tv-pricing': () => <TvPackagePricing />,
    'tv-pricing-v2': () => <TvPackagePricingV2 />,
    'training-management': () => <TrainingManagement />,
    'new-training-management': () => <NewTrainingManagement />,
    'training-test-management': () => <TrainingTestManagement />,
    'email-settings': () => <EmailSettings />,
    'system-reports': () => <SystemReports />,
    'calls-performance-webhook': () => <ZoomIdleReport />,
    sds: () => <SDS />,
    training: () => <TrainingViewer />,
    'new-training': () => <TrainingViewer />,
    'send-offer': () => <SendOffer />,
    'bundle-builder-beta': () => <BundleBuilderPrototype agentBeta />,
    'tv-packages': () => <TvPackageRecommender />,
    'tv-packages-v2': () => <TvPackageRecommenderV2 />,
    'theme-pack-editor': () => <ThemePackEditor />,
    'promo-combo-price': () => <PromoComboViewer />,
    'rogers-pricing': () => <RogersPricingViewer />,
    'my-history': () => <EmailHistory showAllOffers={false} />,
    'all-history': () => <EmailHistory showAllOffers={true} />,
    'bundle-builder': () => <BundleBuilderPrototype />,
    'pricing-manager': () => <ProductPricingManagerComingSoon />,
    'agent-dashboard-manager': () => <AgentDashboardManager />,
    escalations: renderEscalations
});

export const AGENT_VIEW_RENDERERS = Object.freeze({
    dashboard: ({ agentViewMode, escalationsAvailability, escalationsAvailabilityLoaded }) => (
        <AgentDashboardHome
            previewMode={agentViewMode}
            escalationsAvailability={escalationsAvailability}
            escalationsAvailabilityLoaded={escalationsAvailabilityLoaded}
        />
    ),
    'ai-assistant': () => <AIAssistant />,
    training: () => <TrainingViewer />,
    'new-training': () => <NewTrainingViewer />,
    'training-test': () => <TrainingTest />,
    'send-offer': () => <SendOffer />,
    'bundle-builder-beta': ({ agentViewMode }) => <BundleBuilderPrototype agentBeta agentViewMode={agentViewMode} />,
    'tv-packages': () => <TvPackageRecommender />,
    'tv-packages-v2': () => <TvPackageRecommenderV2 />,
    'promo-combo-price': () => <PromoComboViewer />,
    'rogers-pricing': () => <RogersPricingViewer />,
    'my-history': () => <EmailHistory showAllOffers={false} />,
    escalations: renderEscalations
});
